module.exports = __webpack_public_path__ + "img/icon_vip_qq@2x.09fce30f.png";